import React from "react";
import { Box, Image } from "@chakra-ui/react";
import StandeLogo from "../../Images/Stand-logo 1.png";
import { r, s, SHEET_WIDTH, SHEET_HEIGHT } from "./reportTokens";

/**
 * One A4 page of the report (Figma 95:38 "A4 - 1", 96:128 "A4 - 2").
 *
 * Height is a minimum rather than a fix: a paper with long feedback runs past
 * one sheet, and the print stylesheet breaks it across pages rather than
 * clipping it. The logo sits at the same left margin as the content; in Figma
 * it looks further left only because the source PNG carries its own transparent
 * margin.
 */
const ReportSheet = ({ children }) => (
  <Box
    className="report-sheet"
    width={`${SHEET_WIDTH}px`}
    minHeight={`${SHEET_HEIGHT}px`}
    bg={r.page}
    color={r.ink}
    padding={`${s(21)} ${s(25)} ${s(40)}`}
    boxShadow="0 2px 18px rgba(0,0,0,0.10)"
    borderRadius="2px"
  >
    <Image src={StandeLogo} alt="Stande" height={s(23.305)} width="auto" />
    {children}
  </Box>
);

export default ReportSheet;
